var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AlertBar'),(_vm.modal.show)?_c('Modal',{attrs:{"modal":_vm.modal}}):_vm._e(),_c('CookieBar'),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }